export default __webpack_public_path__ + "static/media/icon_v2_bookmark_active_green.7867afe5.svg";